var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_47"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "aqua",
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social",
    transform: "translate(0 0.203)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, -0.2)",
    filter: "url(#Ellipse_47)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47-2",
    "data-name": "Ellipse 47",
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M10.03,7.125a5.143,5.143,0,1,0,5.143,5.143A5.135,5.135,0,0,0,10.03,7.125Zm0,8.487a3.344,3.344,0,1,1,3.344-3.344A3.35,3.35,0,0,1,10.03,15.612Zm6.553-8.7a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,16.583,6.914ZM19.99,8.132a5.937,5.937,0,0,0-1.62-4.2,5.976,5.976,0,0,0-4.2-1.62c-1.656-.094-6.621-.094-8.277,0a5.967,5.967,0,0,0-4.2,1.616,5.956,5.956,0,0,0-1.62,4.2c-.094,1.656-.094,6.621,0,8.277a5.937,5.937,0,0,0,1.62,4.2,5.983,5.983,0,0,0,4.2,1.62c1.656.094,6.621.094,8.277,0a5.937,5.937,0,0,0,4.2-1.62,5.976,5.976,0,0,0,1.62-4.2c.094-1.656.094-6.616,0-8.272ZM17.85,18.181a3.385,3.385,0,0,1-1.907,1.907c-1.321.524-4.454.4-5.913.4s-4.6.116-5.913-.4a3.385,3.385,0,0,1-1.907-1.907c-.524-1.321-.4-4.454-.4-5.913s-.116-4.6.4-5.913A3.385,3.385,0,0,1,4.116,4.448c1.321-.524,4.454-.4,5.913-.4s4.6-.116,5.913.4A3.385,3.385,0,0,1,17.85,6.355c.524,1.321.4,4.454.4,5.913S18.374,16.865,17.85,18.181Z",
    transform: "translate(10.973 8.731)",
    fill: "aqua"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.bc9692dd50cf1f65f7a971bc839f72e2.svg";
export { ForwardRef as ReactComponent };